import { EntityService } from '../../../../service/EntityService';

export class TaxAuthorityService extends EntityService {

  static entity = 'app/tax-authority';

  static getByCode(code: string): Promise<any> {
    return this.axios.get(`${this.entity}/code?code=${code}`);
  }

}
